import { createSelector, createFeatureSelector } from '@ngrx/store';
// ActionReducerMap, combineReducers,
// import { InjectionToken } from '@angular/core';
// import { State } from '@cemex/cmx-client-layout';
// import * as fromOrderSusbcriptionState from './order-subscription.reducer';
// import * as fromDcoState from '@ordersnproducts/modules/shared/reducers/dco.reducer';
import * as fromSlotsState from './slots.reducer';
import * as fromComponentState from './component.reducer';
import * as fromSpecialScenariosState from './special-scenarios.reducer';
import * as VolumeAllocationState from './volume-allocation.reducer';

export const featureKey = 'DCO';

export interface DCOFeatureState {
  component: fromComponentState.State;
  slots: fromSlotsState.State;
  specialScenarios: fromSpecialScenariosState.State;
  volumeAllocation: VolumeAllocationState.VolumeAllocation;
}

export interface VolumeAllocationResult {
  resp: any;
  id: string;
  error?: boolean;
}

// export interface OrdersAndProductsComponentsState extends State {
//   OrdersAndProductsComponentsState: OrdersAndProductsComponentsFeatureState;
// }

export const DCOreducers = {
  component: fromComponentState.reducer,
  slots: fromSlotsState.reducer,
  specialScenarios: fromSpecialScenariosState.reducer,
  volumeAllocation: VolumeAllocationState.reducer,
};

// export const combinedReducers = combineReducers({
//   ...reducers,
// });

// export const reducerToken = new InjectionToken<ActionReducerMap<OrdersAndProductsComponentsState>>('COMBINED_REDUCERS');

// export function getReducers() {
//   return combinedReducers;
// }

// export const reducerProvider = { provide: reducerToken, useFactory: getReducers };

export const getDCOState = createFeatureSelector<DCOFeatureState>(featureKey);

export const getDCOMOO = createFeatureSelector<DCOFeatureState>('multipleOrderOnline');

export const getSlotsMOO = createSelector(getDCOMOO, (state) => {
  return state && state.slots && state.slots.entities && state.slots.entities[0];
});

export const getSlots = createSelector(getDCOState, (state) => {
  return state && state.slots;
});

export const getSlotWithFormID = (formID: number) => {
  return createSelector(getSlots, (state) => {
    if (state) {
      let aux: fromSlotsState.Slot;
      for (const id in state.entities) {
        if (Object.prototype.hasOwnProperty.call(state.entities, id)) {
          const element = state.entities[id];
          if (element.formID === formID) {
            aux = element;
          }
        }
      }
      return aux;
    }
    return undefined;
  });
};

export const getValidated = createSelector(getSlots, (state) => {
  if (state) {
    for (const id in state.entities) {
      if (Object.prototype.hasOwnProperty.call(state.entities, id)) {
        const element = state.entities[id];
        if (element.requestDatetimeIsAvailable) {
          return true;
        }
      }
    }
    if (!!state.selectedSlot && !!state.selectedSlot.deliveryDate) {
      return true;
    }
    return false;
  }
  return false;
});

export const getSelectedSlot = createSelector(getDCOMOO, (state) => {
  return state && state.slots && state.slots.selectedSlot;
});

export const getComponentState = createSelector(getDCOState, (state) => {
  return state && state.component;
});

export const getCutOffDate = createSelector(getComponentState, (state) => {
  return state && state.cutOffDate;
});

export const getOfferDays = createSelector(getComponentState, (state) => {
  return state && state.offerDays;
});

export const getSpecialScenariosState = createSelector(getDCOMOO, (state) => {
  return state && state.specialScenarios;
});

export const getVolumeAllocation = createSelector(getDCOMOO, (state) => state.volumeAllocation);

export const testSpecialScenariosWithFormId = (formId: string) => {
  return createSelector(getSpecialScenariosState, (state) => {
    if (state) {
      let entity: fromSpecialScenariosState.SpecialScenario;
      for (const id in state.entities) {
        if (Object.prototype.hasOwnProperty.call(state.entities, id)) {
          const element = state.entities[id];
          if (element.formId === formId) {
            entity = element;
          }
        }
      }
      if (entity) {
        const specialScenariosTest = entity.valuesAsArray.some((isActive) => isActive === true);
        return specialScenariosTest;
      }
      return undefined;
    }
    return undefined;
  });
};

export const getSpecialScenariosWithFormId = (formId: string) => {
  return createSelector(getSpecialScenariosState, (state) => {
    if (state) {
      let entity: fromSpecialScenariosState.SpecialScenario;
      for (const id in state.entities) {
        if (Object.prototype.hasOwnProperty.call(state.entities, id)) {
          const element = state.entities[id];
          if (element.formId === formId) {
            entity = element;
          }
        }
      }
      return entity;
    }
    return undefined;
  });
};

// export const getOrderSubscriptionComponentEnabled = createSelector(getOrderSubscriptionState, state => {
//   return state.componentEnabled;
// });

// export const getEmails = createSelector(getOrderSubscriptionState, state => {
//   return state.emails;
// });

// export const getPhones = createSelector(getOrderSubscriptionState, state => {
//   return state.phones;
// });

// export const getOrderSubscriptionDestinations = createSelector(
//   getEmails,
//   getPhones,
//   (emails, phones) => {
//     return {
//       emails,
//       phones,
//     };
//   },
// );

// export const getEmailUserSubscriptionToOrder = createSelector(getOrderSubscriptionState, state => {
//   return state.emailSubscribed;
// });

// export const getPhoneUserSubscriptionToOrder = createSelector(getOrderSubscriptionState, state => {
//   return state.phoneSubscribed;
// });

// export const getUserSubscriptionToOrder = createSelector(
//   getEmailUserSubscriptionToOrder,
//   getPhoneUserSubscriptionToOrder,
//   (emailSubscribed, phoneSubscribed) => {
//     return {
//       emailSubscribed,
//       phoneSubscribed,
//     };
//   },
// );

// export const getCanDeleteFirstElement = createSelector(getOrderSubscriptionState, state => {
//   return state.canDeleteFirstElement;
// });

// export const getPhoneCode = createSelector(getOrderSubscriptionState, state => {
//   return state.phoneCode;
// });

// export const getTriggerSubscriptionToOrder = createSelector(getOrderSubscriptionState, state => {
//   return state.triggerCheck;
// });

// export const getShowDiscardModal = createSelector(getOrderSubscriptionState, state => {
//   return state.showDiscardModal;
// });

// export const isUserSubcribing = createSelector(getOrderSubscriptionState, state => {
//   return state.patching;
// });

// // dco

// export const getDcoStatusState = createSelector(getOrdersAndProductsComponentsState, state => {
//   return state.dco.modifyStatusOrder;
// });

// export const getSlotForFormIndex = (formIndex: number) =>
//   createSelector(getSlots, state => {
//     let aux: fromSlotsState.Slot;
//     for (const id in state.entities) {
//       if (Object.prototype.hasOwnProperty.call(state.entities, id)) {
//         const element = state.entities[id];
//         if (element.formIndex === formIndex) {
//           aux = element;
//         }
//       }
//     }
//     return aux;
//   },
// );

export const getDcoEntitiesAsArray = createSelector(getSlots, (state) => {
  const slots: fromSlotsState.Slot[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      slots.push(state.entities[key]);
    }
  }
  return slots;
});
